import fonts from 'const/style/fonts';
import React from 'react';
import styled from 'styled-components';
import GuideImage1 from 'assets/img/guide/guide_1.png';
import GuideImage2 from 'assets/img/guide/guide_2.png';
import GuideImage3 from 'assets/img/guide/guide_3.png';
import GuideImage4 from 'assets/img/guide/guide_4.png';
import GuideImage5 from 'assets/img/guide/guide_5.png';
export const Frame = styled.div` 
white-space:pre-line;
text-align:left;
${fonts.H2_Regular};

height: 100%;
overflow: scroll;

div{
    margin-left:50px;
margin-right:50px;
margin-top:10px;
margin-bottom:50px;
}


&::-webkit-scrollbar
{
	background-color: #FFFFFF;
}
&::-webkit-scrollbar-track {
	background-color: #FFFFFF;
}

&::-webkit-scrollbar-thumb
{
	width: 6px;
	background-color: #474747;
    border-radius: 4px;
}



h1,h2,h3 {
    margin-bottom:-1.0em;
  }
 h1{
   ${fonts.H1_Bold};
 }
 h2{
   ${fonts.H2_Bold};
 }
 .img-box{
     width:100%;
     background: #F3F3F3 0% 0% no-repeat padding-box;
     display: flex;
     justify-content: center;
     align-content: center;
     img{
         object-fit:contain;
     }
 }

 font{
    color: #595BD5;
    font-weight:bold;
 }

`;

export const StepGuideContent = `
<h1>1. 발표자료 PDF 업로드</h1>

<h2>(1) 발표자료 업로드 전</h2>
① 아래는 발표자료 업로드 전 화면입니다. 화면 가운데 위치한 [파일 찾기] 버튼을 클릭하여 발표자료를 업로드하세요.
② 발표자료는 <font>10MB 이하의 PDF 파일</font>만 업로드할 수 있으며, 발표자료에 <font>비밀번호가 걸려 있지 않아야</font> 합니다.

<img class='img-box' src=${GuideImage1}></img>

<h2>(2) 발표자료 업로드 후</h2>
① 아래는 발표자료 업로드가 완료된 화면입니다. 정상적으로 파일 업로드가 완료됐다면 화면 상단에 업로드한 파일의 이름이 표시됩니다.
② 화면 가운데에는 업로드한 파일의 썸네일이 표시되며 스크롤바를 사용하여 처음부터 끝까지 썸네일을 확인할 수 있습니다.
③ 만약 발표자료가 잘못 업로드되었다면 상단의 [파일 변경] 버튼을 클릭하여 다시 업로드할 수 있습니다.
④ 업로드 상태 확인이 끝났다면 화면 하단의 [다음 화면으로 이동] 버튼을 클릭하여 다음 단계를 진행하세요.


<img class='img-box' src=${GuideImage2}></img>

<h1>2. 프레젠테이션 영상/음성 녹화</h1>

<h2>(1) 프레젠테이션 녹화 전</h2>
① 아래는 프레젠테이션 녹화 시작 전 화면입니다. 프레젠테이션을 시작하기 전 2분 간 사용법을 익히고 발표자료를 다시 확인할 수 있습니다.
② 준비 시간은 2분이 주어지며, <font>2분이 종료되면 자동으로 프레젠테이션 녹화가 시작</font>되니 주의해 주세요.
③ 좌상단에서 자신의 영상이 어떻게 나타나는지 확인할 수 있습니다.
④ 발표자료 슬라이드는 좌측의 썸네일을 클릭하거나 하단의 좌우 버튼을 클릭해서 전환할 수 있습니다. 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font>실제 녹화할 때 발표자료 슬라이드를 같이 이동하며 프레젠테이션을 진행하세요.</font>
⑤ 실수로 발표자료를 잘못 업로드한 경우에는 [PDF 파일 변경] 버튼을 클릭하여 다시 발표자료를 업로드할 수 있습니다.
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;단, <font>녹화가 시작된 이후 또는 응시횟수가 3회차인 경우에는 변경할 수 없으니</font> 항상 신중하게 응시에 임해주세요.
⑥ 준비가 완료됐다면 우측 하단의 [녹화 시작] 버튼을 클릭하세요. 버튼을 클릭하면 <font>5초 간 카운트다운 후 바로 녹화가 시작</font>됩니다.
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;녹화가 시작될 때 자동으로 1번 슬라이드로 전환됩니다.

  <img class='img-box' src=${GuideImage3}></img>
  
  <h2>(2) 프레젠테이션 녹화 진행 중</h2>
① 카운트다운이 끝나면 아래처럼 발표자료의 1번 슬라이드부터 화면이 표시됩니다.
② 1번 슬라이드부터 순서 대로 슬라이드를 넘겨 가면서 프레젠테이션을 진행하세요.
③ 프레젠테이션을 진행할 수 있는 <font>남은 시간은 화면 하단에 표시</font>됩니다. <font>남은 시간이 모두 지나면 자동으로 녹화가 종료</font>되니 주의해 주세요.
④ 남은 시간이 모두 지나기 전 프레젠테이션이 완료됐다면 우측 하단의 <font>[완료 및 제출] 버튼을 클릭</font>하세요.
 
<img class='img-box' src=${GuideImage4}></img>

<h1>3. PT전형 종료 안내</h1>

<h2>(1) 안내 화면</h2>
① 프레젠테이션을 종료하면 바로 녹화한 영상이 저장되며 아래와 같이 안내 화면으로 전환됩니다.
② 모든 PT전형 응시가 정상적으로 완료된 상태이며 그대로 브라우저를 종료하시면 됩니다.

<img class='img-box' src=${GuideImage5}></img>

`;



const StepGuide = () => (
    <Frame>
        <div dangerouslySetInnerHTML={{ __html: StepGuideContent }} />
    </Frame>
);

export default StepGuide;
